import i18n from '@/libs/i18n'

export const priorityOptions = [
  {
    value: 'LOW', text: i18n.t('Low'), description: i18n.t('Can be deferred'), color: 'secondary',
  },
  {
    value: 'MEDIUM', text: i18n.t('Medium'), description: i18n.t('Normal workflow'), color: 'success',
  },
  {
    value: 'HIGH', text: i18n.t('High'), description: i18n.t('Should be prioritized'), color: 'warning',
  },
  {
    value: 'URGENT', text: i18n.t('Urgent'), description: i18n.t('Needs immediate attention'), color: 'danger',
  },
]
